import { lidStatusOptions } from './formOptions';

export const LEDEN_HEADERS = [
  'Voornaam',
  'Achternaam',
  'Status',
  'Geboortedatum',
  'Email',
  'Telefoon',
  'Bijzonderheden'
];

export const HEADER_ALIASES = {
  Telefoonnummer: 'Telefoon'
};

export const ALLOWED_STATUSES = lidStatusOptions;
export const MAX_ROWS_PER_UPLOAD = 200;
export const MAX_UPLOAD_FILE_BYTES = 2 * 1024 * 1024;
export const RETENTION_DAYS = 30;
export const VISIBILITY_GRACE_DAYS = 7;

/**
 * Derives number of persons (aantal) represented by a lid status.
 * 'Echtpaar' represents 2 people; all other statuses represent 1 person.
 *
 * @param {string|null|undefined} status
 * @returns {number}
 */
export const deriveLidAantalFromStatus = (status) => {
  return String(status || '').trim().toLowerCase() === 'echtpaar' ? 2 : 1;
};
